export default {"src":"/_next/static/media/description-blob-2.935b49b1.svg","height":315,"width":471,"blurWidth":0,"blurHeight":0};